/**
 * Drafting Center 日本語言語パック
 */
export default {
    draftingCenter: {
    // 時間フォーマット
        time: {
            justNow: 'たった今',
            minutesAgo: '{mins}分前',
            hoursAgo: '{hours}時間前',
            yesterday: '昨日',
            daysAgo: '{days}日前',
        },

        // ナビゲーション
        allDrafts: 'すべての作成',
        loadMore: 'さらに読み込む',
        loadingMore: '読み込み中...',
        recentDrafts: '最近の作成',
        recentDraftsTooltip: '過去3日間に更新された最新5件の作成を表示',
        allProjects: 'すべてのプロジェクト',
        allProjectsRoot: 'すべてのプロジェクト（ルート）',

        // ヘッダー検索とアクション
        searchPlaceholder: 'プロジェクトまたはフォルダを検索...',
        newFolder: '新しいフォルダ',
        sortButton: '並び替え',
        total: '合計',

        // アクション
        create: '作成',
        edit: '編集',
        delete: '削除',
        move: '移動',
        moveTo: '移動先...',
        moveToFolder: 'フォルダに移動',
        moveHere: 'ここに移動',
        save: '保存',
        cancel: 'キャンセル',
        confirm: '確認',
        createFolder: 'フォルダを作成',
        goBack: '戻る',
        enterFolder: 'フォルダに入る',

        // メッセージ
        createSuccess: '作成に成功しました',
        updateSuccess: '更新に成功しました',
        deleteSuccess: '削除に成功しました',
        moveSuccess: '移動に成功しました',
        folderDeletedSuccess: 'フォルダの削除に成功しました',
        projectDeletedSuccess: 'プロジェクトの削除に成功しました',
        deleteItemFailed: 'アイテムの削除に失敗しました',
        createFailed: '作成に失敗しました。もう一度お試しください',
        updateFailed: '更新に失敗しました。もう一度お試しください',
        deleteFailed: '削除に失敗しました。もう一度お試しください',
        moveFailed: '移動に失敗しました。もう一度お試しください',
        fetchFailed: 'データの取得に失敗しました。もう一度お試しください',

        // プロジェクト
        project: {
            name: 'プロジェクト名',
            namePlaceholder: 'プロジェクト名を入力してください',
            description: '説明',
            descriptionPlaceholder: 'プロジェクトの説明を追加',
            updateSuccess: 'プロジェクトの更新に成功しました',
            updateFailed: 'プロジェクトの更新に失敗しました',
        },

        // プロジェクトダイアログ
        projectDialog: {
            title: 'プロジェクト情報を編集',
            projectName: 'プロジェクト名',
            projectNamePlaceholder: 'プロジェクト名を入力してください（例：特許名 - 202510087033.2）',
            optional: '任意',
            descriptionPlaceholder: 'プロジェクトの詳細な説明を追加',
            clientTags: 'クライアントタグ',
            clientTagsDescription: 'プロジェクトを整理およびフィルタリングするためにクライアントタグを追加',
            clientTagsPlaceholder: 'クライアント名を入力または選択',
            save: '保存',
        },

        // フォルダ
        folder: {
            create: 'フォルダを作成',
            createDesc: 'プロジェクトを整理および管理',
            edit: 'フォルダを編集',
            editDesc: 'フォルダ情報を変更',
            name: 'フォルダ名',
            namePlaceholder: 'フォルダ名を入力してください',
            description: '説明',
            descriptionPlaceholder: 'フォルダの説明を追加',
            optional: '任意',
            color: '色',
            colorTip: 'フォルダを識別する色を選択',
            tags: 'タグ',
            tagsTip: 'フィルタリングのためにクライアントタグを追加',
            loadFailed: 'フォルダリストの読み込みに失敗しました',
            inputPlaceholder: 'クライアントを入力または選択',
        },

        // フィルター
        filter: {
            keyword: '検索キーワード',
            workType: '作業タイプ',
            client: 'クライアント',
            status: 'ステータス',
            clearAll: 'フィルターをクリア',
        },

        // 作業タイプフィルター
        workType: {
            all: 'すべて',
            drafting: '作成',
            prosecution: 'OAR',
            disclosure: '開示書',
            '00': '未指定',
            '01': '特許作成',
            '10': '審査意見対応',
            '11': '組み合わせプロジェクト',
            '20': '開示書',
        },

        // ビュー
        view: {
            grid: 'グリッド',
            list: 'リスト',
            board: 'ボード',
            gridView: 'グリッドビュー',
            listView: 'リストビュー',
        },

        // ソート
        sort: {
            name: '名前',
            created: '作成日時',
            updated: '更新日時',
            asc: '昇順',
            desc: '降順',
        },

        // ステータス
        status: {
            draft: '作成中',
            processing: '処理中',
            completed: '完了',
            failed: '失敗',
        },

        // スタイルラベル
        style: {
            standard: '標準',
            detailed: '詳細',
            concise: '簡潔',
        },

        // ダイアログ
        dialog: {
            moreActions: 'その他の操作',
            deleteConfirm: '削除の確認',
            deleteMessage: '選択したアイテムを削除してもよろしいですか？',
            deleteMultipleWarning: '<strong class="text-red-600 font-semibold">{count}</strong> 個のアイテムを削除しようとしています。この操作は元に戻せません。',
            cannotUndo: 'この操作は元に戻せません。',
            andMore: 'その他 {count} 個...',
            deleting: '削除中...',
        },

        // フォルダに移動ダイアログ
        moveDialog: {
            current: '現在の場所',
            moveHereToThisLocation: 'ここに移動',
            cannotMoveHere: 'ここには移動できません',
            moveTo: '移動先...',
            moveHere: 'ここに移動',
            movingProject: '「{name}」を移動中',
            item: '個',
            items: '個',
            noSubfolders: 'サブフォルダがありません',
            noSubfoldersDesc: 'このフォルダにはサブフォルダが含まれていません',
            instructions: '操作説明',
            instructionsText: 'クリックで選択、ダブルクリックまたは矢印でフォルダに入る',
            selectedDestination: '選択した移動先',
            goBack: '戻る',
            enterFolder: 'フォルダに入る',
        },

        // 空の状態
        empty: {
            noProjects: 'プロジェクトがまだありません',
            noResults: '一致するプロジェクトがありません',
            createFirst: '最初のプロジェクトを作成',
            noItemsFound: 'アイテムが見つかりません',
        },

        // カウントのフォーマット
        count: {
            project: '{count}件のプロジェクト',
        },

        // APIエラーメッセージ
        api: {
            fetchProjectsFailed: 'プロジェクトの取得に失敗しました',
            fetchRecentProjectsFailed: '最近のプロジェクトの取得に失敗しました',
            deleteProjectsFailed: 'プロジェクトの削除に失敗しました',
            updateProjectFailed: 'プロジェクトの更新に失敗しました',
            moveProjectsFailed: 'プロジェクトの移動に失敗しました',
            fetchFoldersFailed: 'フォルダの取得に失敗しました',
            fetchAllFoldersFailed: 'すべてのフォルダの取得に失敗しました',
            createFolderFailed: 'フォルダの作成に失敗しました',
            updateFolderFailed: 'フォルダの更新に失敗しました',
            deleteFoldersFailed: 'フォルダの削除に失敗しました',
            moveFolderFailed: 'フォルダの移動に失敗しました',
            fetchStatsFailed: '統計データの取得に失敗しました',
            fetchFiltersFailed: 'フィルターの取得に失敗しました',
        },

        // フォルダ操作メッセージ
        folderCreateFailed: 'フォルダの作成に失敗しました',

        // メタデータ操作
        metadata: {
            clickToCopyOaType: 'クリックしてOAタイプをコピー',
            clickToCopyOaNumber: 'クリックしてOA番号をコピー',
            oaTypeCopied: 'OAタイプをコピーしました',
            oaNumberCopied: 'OA番号をコピーしました',
            applicationNumberCopied: '出願番号をコピーしました',
            copyFailed: 'コピーに失敗しました',
        },

        // システムフォルダ
        systemFolder: {
            name: 'デフォルトフォルダ',
            description: 'システム作成',
            badge: 'システム',
        },

        // 共有
        share: '共有',
        shareDialog: {
            title: 'プロジェクトを共有',
            shareType: '共有タイプ',
            public: '公開',
            company: '会社',
            personal: '個人',
            permission: '権限',
            readOnly: '読み取り専用',
            canEdit: '編集可能',
            expiresAt: '有効期限',
            expiresAtPlaceholder: '有効期限を選択（空欄の場合は無期限）',
            optional: '任意',
            selectUser: 'ユーザーを選択',
            searchUserPlaceholder: '名前またはメールで検索...',
            shareLink: '共有リンク',
            copy: 'コピー',
            close: '閉じる',
            createShare: '共有を作成',
            createSuccess: '共有が作成されました',
            createSuccessAndCopied: '共有が作成され、リンクがクリップボードにコピーされました',
            autoCopyFailed: 'リンクの自動コピーに失敗しました。手動でコピーしてください',
            createFailed: '共有の作成に失敗しました',
            linkCopied: 'リンクがクリップボードにコピーされました',
            copyFailed: 'コピーに失敗しました',
            requireCompanyAccount: '企業アカウントが必要です',
            publicReadOnlyHint: '公開共有は読み取り専用にのみ設定できます',
            companyIdNotFound: '会社情報を取得できません。管理者にお問い合わせください',
            selectUserRequired: '共有するユーザーを選択してください',
            expiry7Days: '7 日間',
            expiry15Days: '15 日間',
            expiry30Days: '30 日間',
            expiryNever: '無期限',
            linkPlaceholder: '共有作成後にリンクが表示されます',
            copyLink: 'リンクをコピー',
            publicHint: 'リンクを持つ誰でもこのプロジェクトを閲覧できます',
            companyHint: '組織のメンバーのみアクセスできます',
            personalHint: '招待された人のみアクセスできます',
        },
    },
};
